module.exports = __webpack_public_path__ + "static/img/teacher-sun.ddc96a1d.png";